import React, { useEffect } from 'react';
import Header from '../components/Header';
import Nav from '../components/Nav';
import AdvancedSkills from './AdvancedSkills';
import Countdown from './Countdown';
import CourseStats from './CourseStats';
import Footer from './Footer';
import FundamentalSkills from './FundamentalSkills';
import Testimonial from './Testimonial';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SocialMediaIcons from '../components/SocialMediaIcons.js';
const Home = () => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1200,
      disable: 'mobile',
      once: true,
    });
  }, []);
  return (
    <div className='h-auto w-full relative'>
      <Nav />
      <Header />
      <FundamentalSkills />
      <Countdown />
      <CourseStats />
      <SocialMediaIcons />
      <Testimonial />
      <Footer />
    </div>
  );
};

export default Home;
